module.exports = __webpack_public_path__ + "images/territory_3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/territory_3.jpg
// module id = 57
// module chunks = 0